import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import { toolsV2CreateAccountResponseSchema } from './common-responses';

export const toolsV2CreateAccountBodyV20260601Schema = z.object({
  toolKey: z.string(),
  strategyName: z.string(),
  displayName: z.string().optional(),
  credentials: z.record(z.string(), z.string()),
});

export type ToolsV2CreateAccountBody = z.infer<
  typeof toolsV2CreateAccountBodyV20260601Schema
>;

export class ToolsV2CreateAccountV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version = 'tools-v2-create-account-2026-06-01' as const;

  readonly name = ToolsV2CreateAccountV20260601Schema.version;
  readonly schema = toolsV2CreateAccountBodyV20260601Schema;
  readonly response = toolsV2CreateAccountResponseSchema;
}

export const TOOLS_V2_API_SCHEMAS = [
  ToolsV2CreateAccountV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
